export function getSchedulePDFPrintPageSx() {
    return {
        boxSizing: "border-box",
        bgcolor: "background.paper",
        color: "text.primary",
        maxWidth: "210mm",
        mx: "auto",
        "@media screen": {
            px: { xs: 2, sm: 4 },
            py: { xs: 2, sm: 4 },
        },
        "@media print": {
            px: "12mm",
            pt: 0,
            pb: 0,
            mx: 0,
            maxWidth: "none",
        },
    }
}

export function getSchedulePDFFooterContentSx() {
    return {
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "space-between",
        gap: 2,
        lineHeight: 1,
        width: "100%",
    }
}

export function getSchedulePDFScheduleUrl(href) {
    if (!href) return ""

    try {
        const url = new URL(href)
        url.pathname = url.pathname.replace(/^\/print\//, "/app/")
        url.searchParams.delete("print")
        url.searchParams.delete("schedulePrint")
        url.searchParams.delete("theme")
        return url.toString()
    } catch {
        return href
    }
}

export function getSchedulePDFFooterQRCodeUrl({ badgeUrl, scheduleUrl } = {}) {
    if (badgeUrl) return badgeUrl
    return scheduleUrl ?? ""
}

export function getSchedulePDFFooterQRCodeCaption({ badgeUrl } = {}) {
    if (badgeUrl) {
        return ["Use this QR code", "to verify SFG20", "license status"]
    }

    return ["Scan to open", "this schedule", ""]
}
